import { SliderSteps, SafeTag, Button, Alert } from '@itau-loans-www/components'
import { useLead } from '@itau-loans-www/hooks'
import IconAviso from '@mobi/ds/static/icons/outlined/aviso.svg'

import Layout from '../../layouts/Summary'
import './blocked-benefit.scss'
import { useBlockedBenefit } from './hooks'
import sliderData from './sliderData'

const BlockedBenefit = () => {
  const {
    closeAlert,
    isAlertVisible,
    carouselConfig,
    handleHelpBtn,
    handleInssBtn,
    isLoading
  } = useBlockedBenefit()

  const { leadData } = useLead()
  const firstName = leadData?.name?.split(' ')[0] ?? ''

  return (
    <Layout>
      <div className="blocked-benefit container">
        <SafeTag />
        <Alert
          isVisible={isAlertVisible}
          paragraph={null}
          icon={<IconAviso />}
          message={`
            <h2>
              Benefício bloqueado
            </h2>
            <p>
              Desbloqueie seu benefício
            </p>
            `}
          closeAlert={closeAlert}
          variant="error"
        />
        <section className="blocked-benefit__intro">
          <h1 className="blocked-benefit__intro-title">
            {firstName}, seu benefício está bloqueado para empréstimo
          </h1>
          <p className="blocked-benefit__intro-subtitle">
            Acesse o aplicativo Meu INSS e solicite o desbloqueio desse
            benefício para continuar com o seu pedido de empréstimo.
          </p>

          <div className="blocked-benefit__btn-wrapper">
            <Button
              id="help-btn"
              variant="secondary"
              onClick={handleHelpBtn}
              isLoading={isLoading}
            >
              Preciso de ajuda
            </Button>
            <Button id="inss-btn" onClick={handleInssBtn}>
              Acessar app Meu INSS
            </Button>
          </div>
        </section>
        <SliderSteps
          title="confira abaixo o passo a passo para o desbloqueio"
          sliderData={sliderData}
          carouselConfig={carouselConfig}
        />
      </div>
    </Layout>
  )
}

export default BlockedBenefit
